import { HTMLAttributes } from 'react'

import cn from '@/utils/tailwind/cn'

export const ModalSuccessIcon = ({
  className,
  ...props
}: HTMLAttributes<HTMLElement>) => (
  <i
    className={cn(
      'mb-4 flex h-20 w-20 items-center justify-center rounded-full bg-green-100/80',
      className
    )}
    {...props}
  />
)
